import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet} from '@simpli/meta-schema'
import {IPrivateCategoryCollectionResourcesHolder} from '@/model/collection/PrivateCategoryCollection'
import {PrivateCategory} from '@/model/resource/PrivateCategory'

export class FilterPrivateCategorySchema extends DefaultSchema
  implements IPrivateCategoryCollectionResourcesHolder {
  readonly name = 'FilterPrivateCategory'

  readonly fieldSet: FieldSet<PrivateCategory> = {}
}
